import DoctorConsultation from '../../doctor/consultation/Consultation';

const ClinicConsultation = () => {
  return <DoctorConsultation />;
};

export default ClinicConsultation;
